import { z } from 'zod';

// ============================================================================
// Scheduler — GET /api/v1/scheduler/status
// ============================================================================

export const SchedulerStatusResponseSchema = z.object({
  visitReminder: z.object({
    enabled: z.boolean(),
    running: z.boolean(),
    config: z.record(z.unknown()),
  }),
  timestamp: z.string().datetime(),
});

export type SchedulerStatusResponse = z.infer<typeof SchedulerStatusResponseSchema>;

// ============================================================================
// Visit Reminder Job Result — POST /api/v1/scheduler/visit-reminders/trigger
// ============================================================================

export const VisitReminderJobResultSchema = z.object({
  startedAt: z.string().datetime(),
  completedAt: z.string().datetime(),
  totalOrders: z.number().int(),
  successCount: z.number().int(),
  failureCount: z.number().int(),
  skippedCount: z.number().int(),
  errors: z.array(
    z.object({
      orderNumber: z.string(),
      error: z.string(),
    }),
  ),
});

export type VisitReminderJobResult = z.infer<typeof VisitReminderJobResultSchema>;

// ============================================================================
// Visit Reminder Health — GET /api/v1/scheduler/visit-reminders/health
// ============================================================================

export const VisitReminderHealthResponseSchema = z.object({
  status: z.enum(['healthy', 'disabled']),
  running: z.boolean(),
  nextRunTime: z.string().datetime(),
});

export type VisitReminderHealthResponse = z.infer<typeof VisitReminderHealthResponseSchema>;
